import { render, staticRenderFns } from "./OnboardingAdminStatus.vue?vue&type=template&id=1901ece4&"
import script from "./OnboardingAdminStatus.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAdminStatus.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAdminStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports